import { createRequest } from '../Api';
import { createRequestError } from '../Reducers/Option/Actions';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

const attachCodeSnippets = (codeSnippets) => {
  if (codeSnippets?.length > 0) {
    codeSnippets.forEach(({ code }) => {
      const fragment = document.createRange().createContextualFragment(code);
      while (fragment.children.length > 0) {
        document.head.insertBefore(fragment.children[0], document.head.firstElementChild);
      }
    });
  }
};

export const useCodeSnippets = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    (async () => {
      const { request } = createRequest();
      try {
        const response = await request({
          url: `frontendapi/codesnippets/getcurrent`,
        });
        attachCodeSnippets(response.data);
      } catch (e) {
        dispatch(createRequestError(e));
      }
    })();
  }, [dispatch]);
};
